<template>
  <footer>
    <div class="main-content">
      <div class="footer-links">
        <router-link :to="{name:'PrivacyPolicy', query:{skin: gaData.skinCode}}"  target="_blank">{{ $t('Privacy Policy') }}</router-link>
        <span>|</span>
        <router-link :to="{name: 'TermsOfUse', query:{skin: gaData.skinCode}}" target="_blank">{{ $t('Terms of Use') }}</router-link>
      </div>
      <span class="copyright" v-if="gaData.skinCode == 'glp' || !this.showCopy">{{ $t('{s} All Rights Reserved.', {s: new Date().getFullYear()}) }}</span>
      <span class="copyright" v-else-if="gaData.skinCode == 'tkl'">{{ $t('{s} All Rights Reserved tkl.', {s: new Date().getFullYear()}) }}</span>
      <span class="copyright" v-else-if="gaData.skinCode == 'pvm'">{{ $t('{s} All Rights Reserved pvm.', {s: new Date().getFullYear()}) }}</span>
      <span class="copyright" v-else>{{ $t('{s} All Rights Reserved gl.', {s: new Date().getFullYear()}) }}</span>
    </div>
  </footer>
</template>

<script>
import {mapState} from 'vuex'

  export default {
    data () {
      return {
        publicPath: process.env.BASE_URL
      }
    },
    computed: {
      ...mapState(['gaData']),
      showCopy () {
        const skinArr = ['tkl', 'glp', 'pvm', 'gl']
        if (skinArr.indexOf(this.gaData.skinCode) === -1) {
          return false
        } else {
          return true
        }
      }
    }
  }

</script>

